/* app/js/src/components/layouts/layout-editor/layout-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  width: 100%;
}
.container {
  height: 100%;
}
.header {
  height: 7%;
}
.header h1 {
  float: left;
  padding-left: 30px;
  font-size: 1.5em;
}
.header p {
  float: right;
}
.body {
  background-color: #f1f3f4;
  height: 93%;
}
.right-side-panel {
  padding: 30px;
  overflow-y: scroll;
}
.left {
  flex-grow: 4;
}
.right {
  border-left: 1px #f1f3f4 solid;
}
.right h2 {
  text-align: center;
}
evrideo-layout-visual-editor {
  margin-top: 30px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.right-panel-header {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 3px;
  display: inline-block;
}
/*# sourceMappingURL=layout-editor.component.css.map */
